import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0fab13f9&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./_footer.css?vue&type=style&index=0&id=0fab13f9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab13f9",
  null
  
)

export default component.exports